module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"1283025442076562"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 805
// module chunks = 142629428675168